module.exports = __webpack_public_path__ + "img/logo.4685cd71.png";